export default {
  init() {
    // JavaScript to be fired on the home page
    document.querySelector('.products-filters__button').addEventListener('click', (e) => {
      const button = e.target;
      const filters = document.querySelector('.products-filters__wrapper');
      const activeClass = 'active';

      button.classList.toggle(activeClass);
      filters.classList.toggle(activeClass);
      button.classList.contains(activeClass) ? button.setAttribute('aria-expanded', 'true') : button.setAttribute('aria-expanded', 'false');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js